import axios from 'axios'

const defaultOptions = {
  headers: {
    accept: 'application/json',
    'accept-encoding': 'utf8',
    'content-type': 'application/json',
  },
  // credentials: 'same-origin',
}

export const isomorphicFetchWrapper = ({ body, data = body, url, headers = {}, ...requestParams }) => {
  const opts = {
    ...defaultOptions,
    ...requestParams,
    headers: {
      ...defaultOptions.headers,
      ...headers,
    },
    url,
    ...(data && { data }),
  }
  return axios
    .request(opts)
    .then(({ data }) => data)
    .catch(({ response, message }) => {
      const body = response?.data ?? message ?? {}
      return Promise.reject({
        body,
        response,
        status: response?.status ?? 500,
      })
    })
}
